import { render, staticRenderFns } from "./ArchiveIconButton.vue?vue&type=template&id=33851d3c&scoped=true&"
import script from "./ArchiveIconButton.vue?vue&type=script&lang=js&"
export * from "./ArchiveIconButton.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveIconButton.vue?vue&type=style&index=0&id=33851d3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33851d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('33851d3c', component.options)
    } else {
      api.reload('33851d3c', component.options)
    }
    module.hot.accept("./ArchiveIconButton.vue?vue&type=template&id=33851d3c&scoped=true&", function () {
      api.rerender('33851d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/Buttons/ArchiveIconButton.vue"
export default component.exports